import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  CheckCircle as UpIcon,
  Error as DownIcon,
  Warning as DegradedIcon,
  Help as UnknownIcon,
} from '@mui/icons-material';

const STATUS_CONFIG = {
  UP: {
    icon: UpIcon,
    color: '#10b981',
    bgColor: '#d1fae5',
    label: 'Online',
  },
  DOWN: {
    icon: DownIcon,
    color: '#ef4444',
    bgColor: '#fee2e2',
    label: 'Offline',
  },
  DEGRADED: {
    icon: DegradedIcon,
    color: '#f59e0b',
    bgColor: '#fef3c7',
    label: 'Degraded',
  },
  UNKNOWN: {
    icon: UnknownIcon,
    color: '#6b7280',
    bgColor: '#f3f4f6',
    label: 'Unknown',
  },
};

export default function ServiceStatusBadge({ status, size = 'small', showLabel = true, error }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.UNKNOWN;
  const StatusIcon = config.icon;

  const badge = (
    <Chip
      icon={<StatusIcon sx={{ fontSize: size === 'small' ? '0.875rem' : '1rem', color: `${config.color} !important` }} />}
      label={showLabel ? config.label : undefined}
      size={size}
      sx={{
        bgcolor: config.bgColor,
        color: config.color,
        fontWeight: 600,
        fontSize: size === 'small' ? '0.7rem' : '0.75rem',
        border: `1px solid ${config.color}30`,
        '& .MuiChip-icon': {
          marginLeft: showLabel ? '4px' : '0',
          marginRight: showLabel ? '-4px' : '0',
        },
        ...(showLabel ? {} : { 
          width: 28, 
          height: 28,
          '& .MuiChip-label': { display: 'none' },
        }),
      }}
    />
  );

  if (error) {
    return (
      <Tooltip title={error} arrow placement="top">
        {badge}
      </Tooltip>
    );
  }

  return badge;
}
